// extracted by mini-css-extract-plugin
export var container = "_5n-0";
export var error = "_5n-9";
export var label = "_5n-5";
export var light = "_5n-6";
export var md = "_5n-3";
export var sm = "_5n-2";
export var thin = "_5n-8";
export var thinBold = "_5n-7";
export var vertical = "_5n-4";
export var xs = "_5n-1";